import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getOrderList = createAsyncThunk(
  "order-listing/getOrderList",
  async (
    {
      page = 1,
      search,
      page_type,
      start_date,
      end_date,
      status,
      delivery_type,
      meal_timing,
    },
    { rejectWithValue },
  ) => {
    try {
      const res = await axiosInstance.get("/order-list", {
        params: {
          page,
          limit: 10,
          search,
          page_type,
          start_date,
          end_date,
          status,
          delivery_type,
          meal_timing,
        },
      });

        // console.log("The res of thunk for order listing is :", res.data);

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const onCancelOrder = createAsyncThunk(
  "order-listing/onCancelOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/cancel-order", payload);
      //   console.log("The cancel order res is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || err || "Something went wrong",
      );
    }
  },
);

export const getOrderDetailById = createAsyncThunk(
  "order-listing/getOrderDetailById",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/get-order-detail", payload);
    //   console.log("The order detail res is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || err || "Something went wrong",
      );
    }
  },
);
